export enum ProjectSystemStatus {
    Open = 'Open',
    Closed = 'Closed'
}

export const ProjectSystemStatues = Object.values(ProjectSystemStatus);

export enum ProjectSystemStatusName {
    Open = 'Open',
    Closed = 'Closed',
}
